import React, { useEffect, useState } from 'react';
import UserLockers from '../components/UserLockers';
import UserDetailsComponent from '../components/UserDetailsComponent';
import { getBulkAdvanceBookingAssignLockers } from '../api/api';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import { LOCAL_STORAGE, USER_INFO } from '../assets/constants/BrowserStorageKeys';
import CircularProgressLoader from '../components/CircularProgressLoader';

// Transform Function
const transformLockerData = (apiData) => {
  if (!apiData || !apiData.data || !Array.isArray(apiData.data)) {
    console.error("Invalid API structure:", apiData);
    return [];
  }

  return apiData.data
    .filter(
      locker =>
        locker.status === "reserved" &&
        locker.payment_status === "completed"
    )
    .map(locker => ({
      amount: locker.amount,
      assignment: locker.assignment,
      currency: locker.currency,
      locker_bank_name: locker.locker_bank_name,
      order_id: locker.order_id,
      payment_id: locker.payment_id,
      payment_status: locker.payment_status,
      ref_id: locker.ref_id,
      reserve_end: locker.reserve_end,
      reserve_start: locker.reserve_start,
      status: locker.status,
      transactions: locker.transactions || [],
      user: locker.user
    }));
};

export default function UserProfilePage() {
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState("Loading...");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setLoadingMessage("Getting user data...");

      const user = await getSecureItemFromSpecificStorage(
        LOCAL_STORAGE,
        USER_INFO
      );
      setUserInfo(user);

      //setLoadingMessage("Fetching locker details...");
    //   const response = await getBulkAdvanceBookingAssignLockers();

    //   if (response) {
    //     const structuredData = transformLockerData(response?.data);
    //     setLockersData(structuredData);
    //   }

    } catch (error) {
      console.error("Error fetching data:", error);
      setLoadingMessage("Something went wrong...");
    } finally {
      setIsLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <div className='user-profile-page'>
      {isLoading ? (
		<div className='main'>
			<CircularProgressLoader message={loadingMessage} />
		</div>
      ) : (
        <div className='main'>
          <div className='heading-container'>
            <h1 className='heading'>My Account</h1>
            <p className='paragraph'>
              Manage your bookings and subscription
            </p>
          </div>

          <div className='user-details-container'>
            <UserDetailsComponent userInfo={userInfo} />
          </div>

          <div className='user-lockers-container'>
            {/* <UserLockers lockersData={lockersData} /> */}
			      <UserLockers/>
          </div>
        </div>
      )}

    </div>
  );
}